import $ from "jquery";

("use strict");

const FIRST_LEVEL_MENU = {
    IS_ACTIVE: 'is-active',
    SELECTOR_JS_RELATED_MENU: '.JS--firstLevelConnectedList',
    SELECTOR_ITEM_MENU: '.dcw_first-level_hidden',
    SELECTOR_CONTAINER_HEADER: '.dcw_main-nav_list',
    SELECTOR_SUBMENU_ITEM: '.js-submenu_item',
    SELECTOR_SUBMENU_MARKER: '.js-marker',
    PROP_DATA_CHANNEL_ID: 'data-channelid',
    SELECTOR_PAGE_TITLE: '.dcw_submenu-auth_wrap-title',
    INITIAL_2NDMARKER_POS: 0
};

// default values
var $container = null;
var $menuToDisplay = null;
var $jsRelatedMenus = null;
var currentPageIsActive = false;

export function processFirstLevelConnected() {
    if (window.cmsUtil.currentChannelBreadcrumb != undefined) {
        $jsRelatedMenus = $(FIRST_LEVEL_MENU.SELECTOR_JS_RELATED_MENU);
        $container = $(FIRST_LEVEL_MENU.SELECTOR_CONTAINER_HEADER);
        var channels = window.cmsUtil.currentChannelBreadcrumb.split(",");

        // channels.length-1 to remove home channel
        for (var i = 0; i < channels.length - 1; i++) {
            var currentChannelIdFromBreadcrumb = channels[i];
            processActiveItemsForFirstLevel(currentChannelIdFromBreadcrumb);
            if (currentPageIsActive) {
                break;
            }
        }
        if (currentPageIsActive) {
            $menuToDisplay.removeClass(FIRST_LEVEL_MENU.CLASS_IS_HIDDEN);
            //initMarker();
        } else {
            $jsRelatedMenus.remove();
        }
    }

}

/**
 * Generate menu associated to the current page for the connected part
 */
function processActiveItemsForFirstLevel(currentChannelIdFromBreadcrumb) {
    var $item = $(FIRST_LEVEL_MENU.SELECTOR_ITEM_MENU + "[" + FIRST_LEVEL_MENU.PROP_DATA_CHANNEL_ID + "=" + currentChannelIdFromBreadcrumb + "]");

    if($item.length) {
        $item.addClass(FIRST_LEVEL_MENU.IS_ACTIVE);
        if ($item.find(FIRST_LEVEL_MENU.SELECTOR_JS_RELATED_MENU).length) {
            $menuToDisplay = $($item.find(FIRST_LEVEL_MENU.SELECTOR_JS_RELATED_MENU).html());

            // display related Menu
            $menuToDisplay.prependTo($container);
            currentPageIsActive = true;
            $(FIRST_LEVEL_MENU.SELECTOR_PAGE_TITLE).remove();
            }
        }
    }


// WEBPACK FOOTER //
// ./src/js/cms/commons/first-level-connected-menu.js